import { customPaymentMethods } from "@jti/fe-common";
import { selectIsPayOnDeliveryEnabled, selectShippingMethodAndCarrier, useSelector } from "@jti/store";
import { useConfig, useTranslations } from "@jti/ui";
import { useFreeTrial } from "../hooks/useFreeTrial";
import { checkIfHomeDelivery } from "../utils/checkIfAtHomeDelivery";
import { useSubscription } from "./useSubscription";
const usePaymentMethods = () => {
    const { __ } = useTranslations();
    const config = useConfig();
    const freeTrialCart = useSelector((state) => state.freeTrialCart);
    const placingOrder = useSelector(({ checkout }) => checkout.placingOrder);
    const orderPending = useSelector(({ freeTrialCart }) => freeTrialCart.checkout.orderPending);
    const pgsNewOrderPaymentToken = useSelector((state) => state.checkout.paymentToken);
    const pgsFreeTrialNewOrderPaymentToken = useSelector((state) => state.freeTrialCart.checkout.paymentToken);
    const cart = useSelector((state) => state.cart);
    const isPaymentMethodsListLoaded = useSelector((state) => state.checkout.isPaymentMethodsListLoaded);
    const pgsPaymentMethods = useSelector((state) => state.checkout.pgsPaymentMethods);
    const pgsAdapter = useSelector((state) => state.checkout.pgsAdapter);
    const hasFreeTrialOrderError = useSelector((state) => state.freeTrialCart.checkout.hasOrderError);
    const isPayOnDeliveryEnabled = useSelector(selectIsPayOnDeliveryEnabled);
    const { isFreeTrial } = useFreeTrial();
    const { isSubscription } = useSubscription();
    const methodAndCarrierCode = useSelector(selectShippingMethodAndCarrier);
    const isAtHomeDelivery = checkIfHomeDelivery(methodAndCarrierCode);
    let paymentMethods = [...pgsPaymentMethods];
    if (!isFreeTrial && isPayOnDeliveryEnabled && (isAtHomeDelivery ? true : config.allowPayInStoreOnDelivery)) {
        const payOnDeliveryPaymentMethod = {
            code: customPaymentMethods.payOnDelivery,
            title: __("cart.order.payment_method.pay_on_delivery"),
            definition: __("cart.order.payment_method.pay_on_delivery.definition"),
        };
        paymentMethods.push(payOnDeliveryPaymentMethod);
    }
    if (isSubscription || isFreeTrial) {
        paymentMethods = paymentMethods.sort((a, b) => (a.tokenizable === b.tokenizable ? 0 : a.tokenizable ? -1 : 1));
    }
    return {
        hasOrderError: isFreeTrial ? hasFreeTrialOrderError : false,
        pgsNewOrderPaymentToken: isFreeTrial ? pgsFreeTrialNewOrderPaymentToken : pgsNewOrderPaymentToken,
        orderPending: isFreeTrial ? orderPending : placingOrder,
        cart: isFreeTrial ? freeTrialCart : cart,
        paymentMethods,
        pgsAdapter,
        isPaymentMethodsListLoaded,
    };
};
export default usePaymentMethods;
//# sourceMappingURL=usePaymentMethods.js.map